import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-show-hide-dialog',
  templateUrl: './show-hide-dialog.component.html',
  styleUrls: ['./show-hide-dialog.component.scss'],
})
export class ShowHideDialogComponent implements OnInit {
  @Input()
  headerNames: any;
  @Input()
  localStorageName: any;
  form: FormGroup;
  headerData: any = [];
  public event: EventEmitter<any> = new EventEmitter();
  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private webStorageService: WebStorageService
  ) {
    this.form = this.formBuilder.group({
      headers: this.formBuilder.array([]),
    });
  }

  ngOnInit() {
    this.addSelectedHeaders();
  }

  addSelectedHeaders() {
    const headers: FormArray = this.form.get('headers') as FormArray;
    if (this.headerNames) {
      for (const val of this.headerNames) {
        if (!val.hide) {
          headers.push(new FormControl(val.name));
        } else {
          let i: number = 0;
          headers.controls.forEach((item: any) => {
            if (item.value == val.name) {
              headers.removeAt(i);
              return;
            }
            i++;
          });
        }
      }
    }
  }
  onCheckboxChange(e: any) {
    const headers: FormArray = this.form.get('headers') as FormArray;
    if (e.target.checked) {
      headers.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      headers.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          headers.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  showHideColumns() {
    for (const col of this.headerNames) {
      col.hide = true;
    }
    for (const col of this.headerNames) {
      for (const val of this.form.value['headers']) {
        if (col.name == val) {
          col.hide = false;
        }
      }
    }
   // console.log(this.headerNames);
    this.webStorageService.setItemInLocalStorage(this.localStorageName, this.headerNames);
    this.event.emit({ data: this.headerNames });
    this.bsModalRef.hide();
  }

  showAllColumns() {
    for (const col of this.headerNames) {
      col.hide = false;
    }
    this.addSelectedHeaders();
    this.showHideColumns();
  }
}
